import React from "react";
import { Box } from "../components/box";
import { Content } from "../components/content";
import { ContentLinks } from "../components/content-links";
import { H1, H2, H3, Text } from "../components/text";
import { Hero } from "../components/hero";
import { Layout } from "../components/layout";
import { Seo } from "../components/seo";
import { TwoColumns } from "../components/two-columns";
import { InlineLink } from "../components/link";
import HeroImage from "../images/pages/about-us/hero.jpg";
import DogVaccinationImage from "../images/pages/about-us/dog-vaccination.jpg";
import WorkingEquineImage from "../images/pages/about-us/working_equine_1.jpg";
import SurgeryImage from "../images/pages/about-us/surgery.jpg";
import SEOImage from "../images/wvs-india-seo.jpg";
import WVSForeignAccounts2425 from "../files/pages/about-us/2024_2025_WVS INDIA CONSOLIDATED ACCOUNTS.pdf";
import WVSForeignAccounts2225 from "../files/pages/about-us/2023_2024_WVS INDIA GENERAL ACCOUNTS.pdf";
import WVSForeignAccounts2224 from "../files/pages/about-us/2023_2024_WVS INDIA FOREIGN CONTRIBUTION ACCOUNTS.pdf";
import WVSForeignAccounts2223 from "../files/pages/about-us/2022_2023_WVS INDIA CONSOLIDATED ACCOUNTS.pdf";
import WVSForeignAccounts2122 from "../files/pages/about-us/2021_2022_WVS INDIA CONSOLIDATED ACCOUNTS.pdf";
import WVSForeignAccounts2021 from "../files/pages/about-us/2020_2021_WVS INDIA CONSOLIDATED ACCOUNTS.pdf";
import WVSForeignAccounts1920 from "../files/pages/about-us/2019_2020_WVS INDIA CONSOLIDATED ACCOUNTS.pdf";
import WVSForeignAccounts1819 from "../files/pages/about-us/2018_2019_WVS INDIA CONSOLIDATED ACCOUNTS.pdf";
import WVSForeignAccounts1718 from "../files/pages/about-us/2017_2018_WVS INDIA CONSOLIDATED ACCOUNTS.pdf";
import WVSForeignAccounts1617 from "../files/pages/about-us/2016_2017_WVS INDIA CONSOLIDATED ACCOUNTS.pdf";

const Index = () => {
  return (
    <Layout>
      <Seo lang='en' title='About us' image={SEOImage} />
      <Hero image={HeroImage}>
        <H1>About us</H1>
      </Hero>
      <Content>
        <H2>WVS India</H2>
        <Text>
          The WVS India Centre in the Nilgiris, Tamil Nadu is run by WVS India,
          a charitable Indian trust that was registered in 2010 on the firm
          foundation that IPAN (India Project for Animals and Nature) had
          already achieved in the animal welfare field. WVS India is recognised
          by the Animal Welfare Board of India (AWBI).
        </Text>
      </Content>
      <Content image={SurgeryImage}>
        <TwoColumns
          renderRight={
            <Box>
              <Text>
                The WVS India centre focuses on providing practical experience
                for veterinarians, animal handlers, veterinary assistants and
                project managers in various aspects of animal health and
                welfare. A major emphasis of our work is in high quality
                spay/neuter (animal birth control) & rabies control–programs and
                in empowering veterinarians from all around India to work in
                these projects to effectively and humanely control dog
                populations for the welfare of dogs and humans. We believe in
                improving animal welfare by veterinary skills development,
                inspiration, and advice.
              </Text>
              <Text>
                Since the establishment of WVS India in 2010, we have built an
                excellent reputation as a centre of excellence providing small
                animal surgery experience programmes in India. We are also known
                for our team of skilled and motivated animal handlers and
                veterinary assistants, who have been working in some of the
                biggest rabies control campaigns across India with Mission
                Rabies.
              </Text>
            </Box>
          }
        />
      </Content>

      <Content variant='secondary'>
        <Text>
          We work in technical collaboration with various international partners
          to provide practical experience in rabies control and humane dog
          population management and improve access to high-quality CPD programs
          for veterinarians in India.
        </Text>
        <Text>
          We also aim to work together with government bodies, ensuring
          sustainability of our activities for the benefit of human and animal
          health and welfare, the One Health-concept.
        </Text>
      </Content>
      <Content>
        <H2>Mission Rabies Goa</H2>
        <Text>
          Mission Rabies in Goa was initiated by WVS India in 2013 in a major
          collaborative program launch that involved the Goan government and the
          Animal Husbandry Department as well as multiple stakeholders across
          India and technical support from international donors and advisors.
        </Text>
        <Text>
          A major milestone for rabies control in Goa came in 2023, when the
          state of Goa was declared a rabies-controlled area through a
          notification from the Directorate of Animal Husbandry and Veterinary
          Services.
        </Text>
        <Text>
          The Mission Rabies program continues in India and is now led by WVS
          Hope. WVS India teams also participate and arrange annual mass dog
          vaccination programs, especially in the Nilgiris district and its
          surroundings. Rabies-free Nilgiris intersectoral, district-level
          committee was established in August 2013 by that time Collector Ms
          Archana Patnaik, IAS and in collaboration with WVS India and Pasteur
          Institute India, Coonoor Director Dr Sekar.
        </Text>
        <Text>
          Over the years WVS India team has been specifically focusing on the
          importance of improving access to annual rabies vaccinations for owned
          dogs, recognising how in small towns and rural areas many free-roaming
          dogs have owners and most of these dogs are accessible for annual
          vaccination by approaching the owners.
        </Text>
        <Text>
          WVS India team has collaborated multiple times with different
          government departments to deliver rabies vaccinations for dogs along
          with other, pre-existing field programs such as the national FMD
          vaccination program by the Animal Husbandry Department or the regular
          village visits by village health inspectors, nurses and asha workers
          by the Public Health Department and Rural Health Mission. 
        </Text>
      </Content>
      <Content image={DogVaccinationImage}>
        <TwoColumns
          renderRight={
            <Box>
              <Text>
                WVS India is working to combat rabies, focusing on three areas
                of work:
              </Text>
              <H3>Mass dog vaccination programs</H3>
              <Text>
                We collaborate with different municipalities, departments and
                other stakeholders to arrange annual vaccination programs in the
                Nilgiris and surroundings to maintain the district free of
                rabies. These programs either focus on door-to-door method in
                village areas where most dogs have owners or caretakers or they
                combine with the use of dog catching teams to also catch
                ownerless dogs for vaccinations.
              </Text>
              <Text>
                While the WVS India team has an excellent dog catching team to
                capture ownerless stray dogs, we are constantly advocating for
                the need to have all owned dogs annually vaccinated as a
                priority. Most owned dogs in small towns and rural India are
                allowed to roam free and unvaccinated owned dogs are a
                significant source of human rabies infections in Tamil Nadu.
              </Text>
              <H3>
                Rabies education and awareness in schools and community meetings
              </H3>
              <Text>
                WVS India education officers visit schools to teach children as
                well as teachers about rabies control, how to avoid dog bites
                and what to do in case of a dog bite. The meetings also include
                awareness of the importance of spay/neuter and annual rabies
                vaccination for all dogs.
              </Text>
              <H3>
                Rabies diagnostics - demonstrations and practicals for
                veterinarians
              </H3>
              <Text>
                WVS India veterinarians perform rabies field diagnostics tests
                to dogs that have been suspected of rabies or dogs that have
                died without known reason. How to perform this test is always
                also demonstrated to any veterinarians attending the WVS India
                surgical development programs.
              </Text>
              <Text>
                Rabies control requires good surveillance program where
                suspected cases are confirmed as positive or negative with
                reliable diagnostic tests and these records and registers are
                maintained to assess the development of rabies incidence in any
                area or territory.
              </Text>
            </Box>
          }
        />
      </Content>
      <Content>
        <H2>Working equine welfare clinics supported by WTG</H2>
        <Text>
          Working donkeys are the lifeblood of rural economies in many
          developing countries, serving important roles in transportation and
          labour. Due to lack of access to veterinary care and extremely
          challenging work environments the donkeys are often subject to major
          welfare issues.
        </Text>
        <Text>
          In India, donkeys are usually used for carrying sand from river bed,
          transporting wood and other goods along hilly terrains and also for
          helping dhobis to carry washed and unwashed clothes. Poor condition of
          the roads they travel, the heavy burdens they bear, the makeshift
          harnesses, combined with inadequate feed and medical attention
          contribute to a life of misery for many working donkeys.
        </Text>
      </Content>
      <Content variant='secondary'>
        <Text>
          Many unconventional techniques are carried out by the owners
          themselves in an attempt to help the donkeys, but often these
          practices cause more pain and discomfort than good. Applying hot iron
          branding to lame and injured legs to facilitate walking, slitting of
          nostrils to improve breathing while going uphill, tipping of ear to
          remove infected blood when the donkey is suffering some illness or if
          he/she had a snake bite, ear cropping for identification and
          beautification are some of the cruelties inflicted upon donkeys by
          their owners out of sheer ignorance.
        </Text>
        <Text>
          These harmful practices could be prevented with improved access to
          veterinary care and animal health knowledge, raising awareness of the
          donkeys’ welfare and building a good rapport with the owners. This is
          what the WVS India working equine welfare project is working on. We
          often also include veterinarians in our clinics to provide them with
          exposure to the welfare of working animals.
        </Text>
      </Content>
      <Content image={WorkingEquineImage}>
        <TwoColumns
          renderLeft={
            <Box>
              <Text>
                Tourist riding horses in popular tourist destinations such as in
                Ooty or Kodaikanal or Mysore are another group of working
                equines that often don’t have access to timely veterinary care.
                WVS India working equine monthly clinics also provide routine
                veterinary care, such as deworming, tetanus vaccinations, hoof
                trimming and teeth rasping for these horses. Stallions are
                surgically castrated by WVS India equine team to make them
                easier to handle. As part of this work with the tourist riding
                horses, we have also arranged specialist farriery skills
                workshops for the horse owners, teaching them some important
                basics of good routine hoof care.
              </Text>
              <Text>
                In Ooty the WVS India equine team also attends to emergencies,
                such as colic due to eating plastic rubbish from the roadside
                rubbish bins or traumatic injuries due to road traffic
                accidents. These are very common since many of these horses
                don’t have proper stables or any kind of sheds where to stay
                when not in use but they are left to roam on the roadsides,
                falling often victim of traffic accidents and gradually losing
                condition because of inadequate feeding. Along with the Nilgiris
                SPCA WVS India has been pushing for more sustainable change in
                the fate of these tourist riding horses by requesting the
                authorities to ban the use of ex-racehorses in tourist riding
                use.
              </Text>
            </Box>
          }
        />
      </Content>
      <Content variant='secondary'>
        <H2>Surgery campaign clinics for owned dogs, Jamtse program </H2>
        <Text>
          Brigitte Bardot Foundation has been supporting WVS India spay/neuter
          work in the Tibetan settlements of Bylakuppe and Kollegal since 2017.
          Initially the program was run as a traditional ABC program whereby
          ownerless stray dogs were caught and brought to the clinic-cum-kennel
          base for surgery. In 2023 the program, known as Jamtse, was changed to
          better address the specific needs of dog owners in small towns to have
          access to affordable spay/neuter surgery for their dogs. WVS India
          outreach surgery team now travels on request to different locations in
          South India to set up and run owned dog campaign clinics. This helps
          owners from low-income households to get their dogs operated and so
          avoid unwanted pregnancies and unwanted puppies that would often get
          abandoned and so eventually add to the ownerless stray dog population.
        </Text>
      </Content>
      <Content>
        <H2>How you can help</H2>
        <Text>
          Support from individuals like you is very important to help us to
          carry on with our work.
        </Text>
        <Text>
          All donations to WVS India are income-tax deductible under the 80G
          Indian income tax Act. There are also many ways you can help by
          donating useful supplies, for example; food for the dogs, blankets,
          towels, feeding bowls, monthly diesel allowance for our dog catching
          vehicle, medicine and surgical materials, instruments, furniture to
          the staff quarters, stationary/office supplies, new shoes for our
          staff...
        </Text>
        <Text>
          WVS India accounts are audited by John Mathews & Co, chartered
          accountants.
        </Text>
        <InlineLink
          href={WVSForeignAccounts2425}
          title='2024-2025 Audited accounts'
        >
          2024-2025 audited accounts
        </InlineLink>
        <br />
        <InlineLink
          href={WVSForeignAccounts2225}
          title='2023-2024 Audited accounts (general)'
        >
          2023-2024 audited accounts (general)
        </InlineLink>
        <br />
        <InlineLink
          href={WVSForeignAccounts2224}
          title='2023-2024 Audited accounts (foreign contribution)'
        >
          2023-2024 audited accounts (foreign contribution)
        </InlineLink>
        <br />
        <InlineLink
          href={WVSForeignAccounts2223}
          title='2022-2023 Audited accounts'
        >
          2022-2023 audited accounts
        </InlineLink>
        <br />
        <InlineLink
          href={WVSForeignAccounts2122}
          title='2021-2022 Audited accounts'
        >
          2021-2022 audited accounts
        </InlineLink>
        <br />
        <InlineLink
          href={WVSForeignAccounts2021}
          title='2020-2021 Audited accounts'
        >
          2020-2021 audited accounts
        </InlineLink>
        <br />
        <InlineLink
          href={WVSForeignAccounts1920}
          title='2019-2020 Audited accounts'
        >
          2019-2020 audited accounts
        </InlineLink>
        <br />
        <InlineLink
          href={WVSForeignAccounts1819}
          title='2018-2019 Audited accounts'
        >
          2018-2019 audited accounts
        </InlineLink>
        <br />
        <InlineLink
          href={WVSForeignAccounts1718}
          title='2017-2018 Audited accounts'
        >
          2017-2018 audited accounts
        </InlineLink>
        <br />
        <InlineLink
          href={WVSForeignAccounts1617}
          title='2016-2017 Audited accounts'
        >
          2016-2017 audited accounts
        </InlineLink>
      </Content>
      <ContentLinks />
    </Layout>
  );
};

export default Index;
